import styled from 'styled-components';
import tw from 'twin.macro';

export const StickyTableHeader = styled.div`
  ${tw`sticky bg-white z-10 rounded-t-md`}
`;
